<template>
  <div id="userInfo">
    <el-container :style="{height:containerHeight}">
      <el-main>
        <div class="main-in">
          <p>个人信息</p>
          <div class="main-item">
            <span class="key">用户账号：</span>
            <span class="value">于维</span>
          </div>
          <div class="main-item">
            <span class="key">公司名称：</span>
            <span class="value">深湾科技有限公司</span>
          </div>
          <div class="main-item">
            <span class="key">所属行业：</span>
            <span class="value">互联网</span>
          </div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="122px"
            :label-position="labelPosition">
            <el-form-item label="负责人：" prop="person">
              <el-input v-model.trim="ruleForm.person" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="性别：" prop="sex">
              <el-radio-group v-model="ruleForm.sex">
                <el-radio label="男"></el-radio>
                <el-radio label="女"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="公司地址：" prop="address">
              <el-input v-model.trim="ruleForm.address" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="tel">
              <el-input v-model.number="ruleForm.tel" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="submitForm" size="small">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "User",
  data () {
    return {
      labelPosition: 'left',
      containerHeight:null,
      ruleForm: {
        person: '',
        sex: '',
        address: '',
        tel: ''
      },
      rules: {
        person: [
          { required: true, message: '请输入负责人名称', trigger: 'blur' },
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入公司地址', trigger: 'blur' },
        ],
        tel: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' },
        ],
      }
    }
  },
  created(){
    this.containerHeight = document.body.clientHeight - 104 + 'px'
  },
  methods: {
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          alert('fail!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.main-in {
  background-color: #fff;
  padding: 24px 0 30px 24px;
}
.main-in p {
  color: #333333;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 29px;
}
.key {
  display: inline-block;
  width: 122px;
  height: 22px;
  color: #666666;
  font-size: 14px;
}
.value {
  color: #333333;
  font-size: 14px;
}
.main-item {
  margin-bottom: 34px;
}
::v-deep .el-input__inner {
  width: 240px;
  height: 32px;
  border-radius: 0%;
}
/*!* 选中后的字体颜色 *!*/
::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #000000 !important;
}
/*!* 选中后小圆点的颜色 *!*/
::v-deep .el-radio__input.is-checked .el-radio__inner {
  background: #77ba00 !important;
  border-color: #77ba00 !important;
}
::v-deep .el-radio__input .el-radio__inner:hover {
  border-color: #77ba00 !important;
}
.el-button--success {
  color: #fff;
  background-color: #77ba00;
  border-color: #77ba00;
  border-radius: 0;
}
</style>